import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IModificationStacksClient, ModificationStacksClient, ValidateModificationStackCommand } from "app/ApiClient";
import { LoadingState } from "types";
import { initialModificationStackValidation } from "./modificationStackValidationState";

const modificationStacksClient: IModificationStacksClient = new ModificationStacksClient(process.env.REACT_APP_API_URL);

export const validateModificationStack = createAsyncThunk(
  "modificationStackValidation/validate",
  async (command: ValidateModificationStackCommand, { rejectWithValue }) => {
    try {
      const result = await modificationStacksClient.validate(command);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const modificationStackValidationSlice = createSlice({
  name: "modificationStackValidation",
  initialState: initialModificationStackValidation,
  reducers: {
    resetModificationStackValidation: () => initialModificationStackValidation,
  },
  extraReducers: (builder) => {
    // validateModificationStack
    builder.addCase(validateModificationStack.pending, (state) => {
      state.loading = LoadingState.pending;
      state.result = null;
    });
    builder.addCase(validateModificationStack.fulfilled, (state, { payload }) => {
      state.loading = LoadingState.succeed;
      state.result = payload;
    });
    builder.addCase(validateModificationStack.rejected, (state, { error: { message } }) => {
      state.loading = LoadingState.failed;
      state.errors = message ?? null;
    });

  },
});
export const { resetModificationStackValidation } = modificationStackValidationSlice.actions;
export default modificationStackValidationSlice.reducer;
